import Crud from './crud'
import {upload_file} from '@/commons/hpod';
import { refreshResource } from '@/commons/utils';
import Vue from 'vue';
var crud = new Crud('files', 'hình ảnh');

const state = {
    ...crud.state,
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    upload_file({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file("files", res => {
            commit("setLoading", { loading: false });
            refreshResource();
        }, Vue.http, formData, this.state.authentication.token, 'upload');
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};